import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { ArticleContainer } from '_core/components/ArticleContainer'

// @material-ui
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from '@material-ui/core'
import { useTheme, withStyles } from '@material-ui/styles';


// style
import { bannerListItemStyle } from './bannerListItemStyle'

const RawBannerListItem = props => {
  const {
	  data,
	  classes,
	  baseUrl,
	  hasActions,
	  } = props

  const theme = useTheme();
  const content = (
    <>
	  
	  <CardMedia image={data.photo.id ? data.photo.path : null} 
	     title={data.photo.id ? data.title : null} 
	     className={theme.variables.topBannerAspectRatioPersent !== 'unset' ? (classes.bannerItemContainer + ' ' + classes.fullHeight) : classes.bannerItemContainer}>
		<CardContent className={classes.bannerItemFull}>
		  {data.title ? (
			<Typography
        gutterBottom
        color="bannerColor"
        variant="body1"
        component="h1"
			  className={classes.bannerItemTitle}
			>
        {data.title}
			</Typography>
		  ) : null}
        {data.description ? (
			<Typography
			  color="bannerColor"
			  component="p"
			  className={classes.bannerItemDescription}
			>
        {data.description}
			</Typography>
		  ) : null}
		</CardContent>
		
		{data.content ? (
		  <ArticleContainer
		    className={classes.bannerItemContent}
				color="bannerColor"
				variant="body2"
		  >
				{data.content}
		  </ArticleContainer>
		) : null}
      </CardMedia>
    </>
  )

  const renderLink = children =>
    data.link_replaced ? (
      <a target="_blank" rel="noopener noreferrer" href={data.link}>
        {children}
      </a>
    ) : (
      <Link to={`${baseUrl}/${data.name != null ? data.name : data.id}`}>
        {children}
      </Link>
    )

  return (
    <Card>
      <CardActionArea className={theme.variables.topBannerAspectRatioPersent !== 'unset' ? classes.bannerItemRatio : null}>
        {hasActions ? renderLink(content) : content}
      </CardActionArea>
    </Card>
  )
}

RawBannerListItem.defaultProps = {
  hasActions: true,
}

RawBannerListItem.propTypes = {
  // self props
  hasActions: PropTypes.bool,
  data: PropTypes.object.isRequired,
  baseUrl: PropTypes.string.isRequired,

  // `withStyles` HOC props
  classes: PropTypes.object.isRequired
}

export const BannerListItem = withStyles(bannerListItemStyle)(RawBannerListItem)
